(function () {
  class SymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this._movies = [];
      this._glows = [];
      this._moviePool = {};
      this._completeCb = undefined;
      this._trackedSymbols = {};
      this._moveisCreated = 0;
      this.symbols = undefined;
      this.slotMachine = undefined;

      this.delay = (ms) => new Promise((res) => setTimeout(res, ms));

      Reflex.registerEventHandler('layoutChange', this.onOrientationChange.bind(this));
    }

    getMovie(reservedSpace, symbolName) {
      let movie = undefined;

      if (this._moviePool['' + reservedSpace] && this._moviePool['' + reservedSpace].length > 0) {
        movie = this._moviePool['' + reservedSpace].pop();
      } else {
        if (symbolName === 'WI') {
          movie = resourceManager.createObject('movie', 'Symbol_Wild' + this._moveisCreated, this.name, {
            definition: `Symbol_Wild`,
          });
        } else if (symbolName === 'SWI') {
          movie = resourceManager.createObject('movie', 'Symbol_SuperWild' + this._moveisCreated, this.name, {
            definition: `Symbol_SuperWild`,
          });
        } else {
          movie = resourceManager.createObject('movie', `${symbolName}` + this._moveisCreated, this.name, {
            definition: `${symbolName}`,
          });
        }

        ++this._moveisCreated;
      }
      return movie;
    }

    initialiseSymbolMovie(movie, symbolId, symPos) {
      movie.visible = true;
      movie.gotoAndStop(0);
      movie.position.set(symPos.x, symPos.y);
    }

    //NOTE: Dont like how this has been done! we only want to make the winning symbols pop
    highlightWinningSymbols(movie, symbolId, symPos) {
      movie.visible = true;
      movie.gotoAndPlay(0);
      movie.position.set(symPos.x, symPos.y);
    }

    onSymbolTracked(trackInfo) {
      let movie = this.getMovie(trackInfo.reservedSpace);
      movie.uniqueId = trackInfo.uniqueSymbolId;

      this.initialiseSymbolMovie(movie, trackInfo.symbolId, trackInfo.getPosition(), trackInfo.clipBounds);
      this._movies.push(movie);
      trackInfo.showSymbol(false);

      this._trackedSymbols['ID_' + trackInfo.reelId + '_' + trackInfo.uniqueSymbolId] = trackInfo;
      let self = this;
      timerManager.addTimer(700, undefined, function () {
        if (self._trackedSymbols.hasOwnProperty('ID_' + trackInfo.reelId + '_' + trackInfo.uniqueSymbolId)) {
          self._trackedSymbols['ID_' + trackInfo.reelId + '_' + trackInfo.uniqueSymbolId].untrack();
        }
      });
    }

    onSymbolUntracked(trackInfo) {
      if (this._trackedSymbols.hasOwnProperty('ID_' + trackInfo.reelId + '_' + trackInfo.uniqueSymbolId)) {
        delete this._trackedSymbols['ID_' + trackInfo.reelId + '_' + trackInfo.uniqueSymbolId];
      }

      for (let i = 0; i < this._movies.length; ++i) {
        if (this._movies[i].uniqueId === trackInfo.uniqueSymbolId) {
          this._movies[i].uniqueId = undefined;
          this._movies[i].visible = false;
          if (this._moviePool['' + trackInfo.reservedSpace] === undefined)
            this._moviePool['' + trackInfo.reservedSpace] = [];

          this._moviePool['' + trackInfo.reservedSpace].push(this._movies[i]);
          this._movies.splice(i, 1);
          break;
        }
      }

      if (this._movies.length === 0) {
        this._completeCb();
      }
    }

    skip() {
      for (let prop in this._trackedSymbols) {
        if (this._trackedSymbols.hasOwnProperty(prop)) {
          this._trackedSymbols[prop].untrack();
        }
      }
    }

    animateSymbols(symbols, slotMachine, canCelebrate, callback) {
      this._trackedSymbols = [];
      this._completeCb = callback;

      for (let i = 0; i < symbols.length; ++i) {
        let data = symbols[i];
        slotMachine.trackSymbolInWindow(
          data.cell.reel,
          data.cell.row,
          data.symbolId,
          this.onSymbolTracked.bind(this),
          this.onSymbolUntracked.bind(this)
        );
      }
    }
  }

  let create = function () {
    return new SymbolAnimator();
  };

  let initialise = function (json, instance) {};

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType('symbolAnimator', create, initialise, getRequiredFiles);

  class SymbolAnimatorDFF extends SymbolAnimator {
    constructor() {
      super();

      this._glows = [];
      this._glowsCreated = 0;
      this._glowPool = [];
      this._spines = [];
      this._spinesCreated = 0;
      this._spinePool = [];
    }

    getGlowMovie() {
      let movie = undefined;
      if (this._glowPool.length > 0) {
        movie = this._glowPool.pop();
      } else {
        movie = resourceManager.createObject(
          'movie',
          `symbolWinFrame${this._glowsCreated}`,
          'slotContainer:reelContainer:symbolWinFrameContainer',
          {
            definition: 'symbolWinFrame',
            anchor: 0.5,
            scale: 1.0,
            loop: false,
          }
        );

        movie.loop = false;
        ++this._glowsCreated;
      }
      return movie;
    }

    onSymbolTracked(trackInfo) {
      super.onSymbolTracked(trackInfo);
    }

    cleanUp() {
      //Check if symbols exists first to prevent an error
      if (this.symbols) {
        for (let i = 0; i < this.symbols.length; ++i) {
          if (this.symbols[i] != null) {
            gameData.reels[this.symbols[i].cell.reel].showSymbol(this.symbols[i].cell.row, true);
          }
        }
        for (let i = 0; i < this._movies.length; ++i) {
          resourceManager.destroyObject(this._movies[i].Props.FQN);
          this._movies[i].uniqueId = undefined;
          this._movies[i].visible = false;
        }
        for (let i = 0; i < this._glows.length; ++i) {
          this._glows[i].uniqueId = undefined;
          this._glows[i].visible = false;
          this._glows[i].gotoAndStop(0);
          this._glowPool.push(this._glows[i]); //NOTE: I think this is recyling pre made glows
        }
        this._movies = [];
        this._glows = [];
      }
    }

    onSymbolUntracked(trackInfo) {}

    scaleActiveSpines() {
      for (let i = 0; i < this._spines.length; ++i) {
        let spine = this._spines[i];
        spine.scale.x = spine.targetScaleX;
        spine.scale.y = spine.targetScaleY;
      }
    }

    animateScalingSymbols(direction, symbolsToAnimate, lineDurations, slotMachine) {
      let symbols = [];
      symbolsToAnimate.forEach((s) => {
        const index = s.cell.reel;
        symbols[index] = s;
      });

      const isRightToLeft = direction === -1;
      if (isRightToLeft) {
        symbols = symbolsToAnimate.toReversed();
      }

      this.symbols = symbols;
      this.slotMachine = slotMachine;

      let delay = 0;
      for (let i = 0; i < gameData.numReels; i++) {
        if (symbols[i] != null) {
          const animFadeInDuration = 0.1;
          const animFadeOutDuration = 0.3;
          const animTotalDuration = animFadeInDuration + lineDurations[i] + animFadeOutDuration;

          gameData.reels[symbols[i].cell.reel].scaleSymbol(symbols[i].cell.row, animTotalDuration, delay);
        }
        delay += lineDurations[i];
      }
    }

    animateScalingSymbolsAtSameTime(symbolsToAnimate, slotMachine) {
      this.symbols = symbolsToAnimate;
      this.slotMachine = slotMachine;
      symbolsToAnimate.forEach((symbol) => {
        gameData.reels[symbol.cell.reel].scaleSymbol(symbol.cell.row, 1.4);
      });
    }

    hasAnimation(symbolId) {
      const config = resourceManager.getConfiguration();
      const symbolName = Object.keys(config.symbols)[symbolId];

      return (config.textureLists[symbolName].totalFrames ?? 0) > 1;
    }

    animateSymbols(symbols, slotMachine, canCelebrate, loop, callback, keepSymbolsOnTop, symbolAnimCb) {
      //TODO: Needs tidying up
      this._completeCb = callback;
      this.symbols = symbols;
      this.slotMachine = slotMachine;
      let self = this;

      for (let i = 0; i < symbols.length; ++i) {
        let cell = symbols[i].cell;
        let symPos = slotMachine.getSymbolPosition(cell.reel, cell.row, false);
        symPos.y = symPos.y + this.getSymYOffSet(symbols[i]);
        let scale = 1;
        let gmPos = {
          x: symPos.x + (gameData.symbolWidth / 2) * scale,
          y: symPos.y + (gameData.symbolWidth / 2) * scale,
        };

        let symbolName = Object.keys(resourceManager.getConfiguration().symbols)[symbols[i].symbolId];
        gameData.reels[cell.reel].showSymbol(cell.row, false);

        const animOffset = resourceManager.getConfiguration().symbols[symbolName].animOffset;
        symPos.x = symPos.x + animOffset.x;
        symPos.y = symPos.y + animOffset.y;

        if (canCelebrate) {
          let symbolMovie = this.getMovie(1, symbolName);

          const slotCell = cell.reel * gameData.numRows + cell.row;
          if (symbolAnimCb !== undefined && i == 0) {
            symbolAnimCb();
          }
          // Jamie - is this from previous game?
          if (symbols[i].symbolId === 12) {
            // gameController.overSizedSymbols.hideOversizedSymbols();
            // symbolMovie.loop = false;
            // symbolMovie.onComplete = function () {
            //   if (i === 0) {
            //     let cb = self._completeCb;
            //     self._completeCb = undefined;
            //     cb();
            //   }
            //   gameController.overSizedSymbols.showOversizedFS(slotCell);
            // };
          } else if (keepSymbolsOnTop && i === 0) {
            //this is for freespins entry
            symbolMovie.onComplete = function () {
              let cb = self._completeCb;
              self._completeCb = undefined;
              cb();
            };
          }

          this.initialiseSymbolMovie(symbolMovie, symbols[i].symbolId, symPos);
          this._movies.push(symbolMovie);
          this.highlightWinningSymbols(symbolMovie, symbols[i].symbolId, symPos);
        } else {
          let scale = 1;

          if (gameController.fsBonusSymbolsLanded < 3) {
            gameController.overSizedSymbols.dimOversizedFS(true);
          }

          let symbolMovie = this.getMovie(1, symbolName);

          symbolMovie.scale.set(scale, scale);

          this.initialiseSymbolMovie(symbolMovie, symbols[i].symbolId, symPos);

          this._movies.push(symbolMovie);
        }
        let glowMovie = this.getGlowMovie();

        // Haven't decided yet whether the winline animation or symbol anim will dictate winline speed
        // So this animation will run inisibly for now. On completion of this anim the animateSymbols callback is called.
        glowMovie.visible = false;

        glowMovie.anchor.set(0.5);

        glowMovie.position.set(gmPos.x, gmPos.y);

        this._glows.push(glowMovie);

        //Only need to set the oncomplete on the last one
        glowMovie.onComplete = function () {
          if (gameController.fsBonusSymbolsLanded < 3) {
            gameController.overSizedSymbols.dimOversizedFS(false);
          }

          self.skip(); //complete the callback
        };
        glowMovie.gotoAndPlay(0);
      }
    }

    onOrientationChange() {
      if (this.symbols && this._movies.length > 0) {
        let symYOffset = this.getSymYOffSet();
        let symXOffset = 0;
        for (let i = 0; i < this.symbols.length; ++i) {
          if (this.symbols[i] != null) {
            let cell = this.symbols[i].cell;
            let symPos = this.slotMachine.getSymbolPosition(
              cell.reel,
              // We need to force this animation to row 1 if its an expanded super wild
              this.symbols[i].symbolId === 9 ? 0 : cell.row,
              false
            );

            let gmPos = {
              x: symPos.x + gameData.symbolWidth / 2,
              y: symPos.y + gameData.symbolWidth / 2,
            };

            this._movies[i].position.set(symPos.x + symXOffset, symPos.y + symYOffset);

            if (this._glows[i] !== undefined) {
              this._glows[i].position.set(gmPos.x, gmPos.y);
            }
          }
        }
      }
    }

    getSymYOffSet() {
      let symYOffset;
      switch (layoutController.getCurrentLayout()) {
        case 'landscape_default':
          symYOffset = 0;
          break;
        case 'landscape_mobile':
          symYOffset = 0;
          break;
        case 'portrait_default':
          symYOffset = 0;
          break;
        case 'portrait_mobile':
          symYOffset = 0;
          break;
      }
      return symYOffset;
    }

    skip() {
      if (this._movies && this._movies.length !== 0) {
        this.cleanUp();
        for (let i = 0; i < this._movies.length; ++i) {
          this._movies[i].uniqueId = undefined;
          this._movies[i].visible = false;
          if (this._moviePool['1'] === undefined) this._moviePool['1'] = [];

          this._moviePool['1'].push(this._movies[i]);
        }
        for (let i = 0; i < this._glows.length; ++i) {
          this._glows[i].uniqueId = undefined;
          this._glows[i].visible = false;
          this._glows[i].gotoAndStop(0);
          this._glowPool.push(this._glows[i]);
        }
        this._movies = [];
        this._glows = [];

        if (this._completeCb !== undefined) {
          let cb = this._completeCb;
          this._completeCb = undefined;
          cb();
        }
      }
    }
  }

  let createHM = function () {
    return new SymbolAnimatorDFF();
  };

  let getRequiredFilesDFF = function () {
    return [];
  };

  resourceManager.registerObjectType('SymbolAnimatorDFF', createHM, initialise, getRequiredFilesDFF);
})();
